import styled from "styled-components";

export const VerticalNavigationWrapper = styled.div`
    padding: 8px 16px 8px 16px;
    display: flex;
    align-items: center;
`;
